// Coffeescript transformed to Javascript via https://awsm-tools.com/code/coffee2js
// See: http://getcontenttools.com/tutorials/adding-new-tools

import ContentTools from 'ContentTools/build/content-tools.min.js';
import { coffeeExtends } from './helpers';

export const initMediaPartnersTool = function () {
    (function (_super) {
        coffeeExtends(MediaPartnersTool, _super);
        function MediaPartnersTool() {
            return MediaPartnersTool.__super__.constructor.apply(this, arguments);
        }
        ContentTools.ToolShelf.stow(MediaPartnersTool, 'partners');
        MediaPartnersTool.label = 'Insert Media Partners';
        MediaPartnersTool.icon = 'partners';
        MediaPartnersTool.tagName = 'mp';
        MediaPartnersTool.canApply = element => {
            return element.tagName() === 'p';
        };
        MediaPartnersTool.apply = (element, selection, callback) => {
            const cursor = selection.get()[0] + 1;

            const tip = element.content.substring(0, selection.get()[0]);
            const tail = element.content.substring(selection.get()[1]);
            const mpHtml = ` <${MediaPartnersTool.tagName} contenteditable="false">MEDIA PARTNERS TABLE</${
                MediaPartnersTool.tagName
            }> `;
            element.content = tip.concat(mpHtml, tail);
            element.updateInnerHTML();
            element.taint();

            // Restore the selection
            selection.set(cursor + 20, cursor + 20);
            element.selection(selection);

            ContentTools.Tools.LineBreak.dispatchEditorEvent('tool-applied', {
                name: 'CKP_PartnersTool',
                transform: true
            });

            callback(true);
        };
        return MediaPartnersTool;
    })(ContentTools.Tools.LineBreak);
};
